import type { RouteRecordRaw } from "vue-router";
import AppLayout from "@/layouts/AppLayout.vue";
import { adminGuard } from "../routerHelpers";

export const adminRoutes: RouteRecordRaw[] = [
  {
    name: "admin",
    path: "/admin",
    component: AppLayout,
    redirect: { name: "admin-dashboard" },
    beforeEnter: adminGuard,
    children: [
      {
        name: "admin-dashboard",
        path: "dashboard",
        component: () => import("@/pages/admin/AdminDashboard.vue"),
        meta: { title: "Dashboard Administrateur" },
      },
    ],
  },
];
